import React from 'react';
import { Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { View } from 'react-native-web';
import { BodyText } from '../../../ui';

type ServiceGroupHeaderProps = {
  serviceName: string;
  serviceCount: number;
};

export const ServiceGroupHeader = React.forwardRef<View, ServiceGroupHeaderProps>(({
  serviceName, serviceCount,
}, ref) => (
  <Inline
    alignItems="center"
    space={4}
    id={serviceName}
    ref={ref}
  >
    <BodyText appearance="large" weight="bold" color={BrandColor.Metal}>{serviceName || 'Services'}</BodyText>
    <BodyText color={BrandColor.Ash}>({serviceCount})</BodyText>
  </Inline>
));
